// Copyright (c) 2016 Deere & Company

import './index.scss';
import React, {PropTypes} from 'react';
import ClaimAction from '@deere/cps-it.warranty-model-factory/lib/claim-action';
import ClaimActionButton from '../../../shared/components/claim-action-button';
import ClaimVsrMessage from '@deere/cps-it.warranty-model-factory/lib/claim-vsr-message';
import {FormattedMessage} from 'react-intl';
import VsrMessagePopover from '../../../shared/components/vsr-popover';
import {formatClaimNumber} from '../../../../shared/services/format-claim-number';
import {getAllowedActions} from '../../../shared/services/claim-shared-helper';

const ClaimStickyHeader = props =>
    <header className='claim-sticky-header'>
        <div className='claim-header-details'>
            <h2>
                {props.claimNumber ?
                    <FormattedMessage
                        id='CLAIM_WITH_NUMBER'
                        values={{claimNumber: formatClaimNumber(props.claimNumber)}}
                    /> :
                        <FormattedMessage id='NEW_CLAIM'/>
                }
            </h2>
            <VsrMessagePopover
                errorMessages={props.errorMessages}
                infoMessages={props.infoMessages}
                isEditable={props.isEditable}
                warningMessages={props.warningMessages}
            />
        </div>
        {props.allowedActions.length &&
            <ClaimActionButton
                allowedActions={getAllowedActions(props.isEditable, props.allowedActions)}
                claimNumber={props.claimNumber}
                claimStatus={props.claimStatus}
                className='claim-action-button'
                creditMemoNumber={props.creditMemoNumber}
                isActionButtonDisabled={props.isActionButtonDisabled}
                isEditable={props.isEditable}
                onActionClick={props.onActionClick}
            />
        }
    </header>;

ClaimStickyHeader.displayName = 'ClaimStickyHeader';
ClaimStickyHeader.propTypes = {
    allowedActions: PropTypes.arrayOf(PropTypes.instanceOf(ClaimAction)).isRequired,
    claimNumber: PropTypes.string.isRequired,
    claimStatus: PropTypes.string.isRequired,
    creditMemoNumber: PropTypes.string.isRequired,
    errorMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired,
    infoMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired,
    isActionButtonDisabled: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    onActionClick: PropTypes.func.isRequired,
    warningMessages: PropTypes.arrayOf(PropTypes.instanceOf(ClaimVsrMessage)).isRequired
};

export default ClaimStickyHeader;



// WEBPACK FOOTER //
// ./src/claim/shared/components/claim-sticky-header/index.js